import COPY from './switch_copy.json';

export const SWITCH_LANGS = [['en', 'EN', '/driveline/switch'], ['hi', 'हिंदी', '/driveline/switch/hi'], ['kn', 'ಕನ್ನಡ', '/driveline/switch/kn']];
export const switchCopy = (lang) => COPY[lang] || COPY.en;
export const FILE_TAG_KEYS = ['customers', 'vehicles', 'balances', 'stock', 'other'];
export const FILE_ACCEPT = '.xlsx,.xls,.csv,.pdf,.png,.jpg,.jpeg,.webp';
export const checklistPdf = (lang) => `/driveline/switch/driveline-switch-checklist-${lang}.pdf`;
